import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, MapPin, Phone, Mail } from "lucide-react";
import { RESTAURANT, IMG } from "@/data/restaurant";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[var(--infuse-emerald-dark)] text-[#F8FAFC] overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-30 pointer-events-none"
        style={{ backgroundImage: `url(${IMG.emeraldBg})`, backgroundSize: "cover", backgroundPosition: "center" }}
      />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-20 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-baseline gap-2">
            <span className="font-display text-5xl text-white">Infuse</span>
            <span className="font-eyebrow text-[var(--infuse-gold-soft)]">St Albans</span>
          </div>
          <p className="mt-5 text-white/70 max-w-md leading-relaxed">
            Elevated flavours. Modern restaurant soul. A chic, contemporary Indian dining experience tucked away just off St Peter's Street.
          </p>
          <div className="mt-6 flex items-center gap-4">
            <a aria-label="Instagram" href="https://www.instagram.com/infusestalbans/" target="_blank" rel="noopener noreferrer" data-testid="social-instagram" className="p-2 border border-white/15 hover:border-[var(--infuse-gold)] transition">
              <Instagram size={18} strokeWidth={1.5} />
            </a>
            <a aria-label="Facebook" href="https://www.facebook.com/infusestalbans" target="_blank" rel="noopener noreferrer" data-testid="social-facebook" className="p-2 border border-white/15 hover:border-[var(--infuse-gold)] transition">
              <Facebook size={18} strokeWidth={1.5} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-eyebrow text-[var(--infuse-gold-soft)] mb-4">Visit</h4>
          <p className="flex items-start gap-3 text-white/80 text-sm leading-relaxed">
            <MapPin size={16} strokeWidth={1.5} className="mt-0.5 text-[var(--infuse-gold-soft)]" />
            <span>{RESTAURANT.address}</span>
          </p>
          <p className="mt-3 flex items-center gap-3 text-white/80 text-sm">
            <Phone size={16} strokeWidth={1.5} className="text-[var(--infuse-gold-soft)]" />
            <a href={RESTAURANT.phoneHref} className="hover:text-[var(--infuse-gold-soft)]">{RESTAURANT.phone}</a>
          </p>
          <p className="mt-3 flex items-center gap-3 text-white/80 text-sm">
            <Mail size={16} strokeWidth={1.5} className="text-[var(--infuse-gold-soft)]" />
            <a href={`mailto:${RESTAURANT.email}`} className="hover:text-[var(--infuse-gold-soft)]">{RESTAURANT.email}</a>
          </p>
        </div>

        <div>
          <h4 className="font-eyebrow text-[var(--infuse-gold-soft)] mb-4">Explore</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/story" className="hover:text-[var(--infuse-gold-soft)]">Our Story</Link></li>
            <li><Link to="/menu" className="hover:text-[var(--infuse-gold-soft)]">The Menu</Link></li>
            <li>
              <a href={RESTAURANT.bookUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-book-link" className="hover:text-[var(--infuse-gold-soft)]">
                Book a Table
              </a>
            </li>
            <li>
              <a href={RESTAURANT.orderUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-order-link" className="hover:text-[var(--infuse-gold-soft)]">
                Order Online
              </a>
            </li>
            <li><Link to="/contact" className="hover:text-[var(--infuse-gold-soft)]">Private Events</Link></li>
          </ul>
        </div>
      </div>

      <div className="relative border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between text-xs text-white/50">
          <p>© {new Date().getFullYear()} Infuse Modern Indian Restaurant. All rights reserved.</p>
          <p className="mt-2 md:mt-0">Crafted with saffron, slate &amp; brass.</p>
        </div>
      </div>
    </footer>
  );
}
